import { render, staticRenderFns } from "./VipPartnersTabLinks.vue?vue&type=template&id=13a87a83"
import script from "./VipPartnersTabLinks.vue?vue&type=script&lang=js"
export * from "./VipPartnersTabLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports